/**
 * Subscription Management Platform API
 * This document describes the functionality of the API belonging to the Subscription Management Platform ## Parameters ### Parameters with type \"array[string]\" or \"array[integer]\" should be given as multiple parameters with same key and different values    * param=A&param=B&param=C    * param=0&param=1&param=2
 *
 * OpenAPI spec version: 2.0.7
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CERTIFICATE } from './cERTIFICATE';
import { EISSHORT } from './eISSHORT';
import { KEYSETINFO } from './kEYSETINFO';
import { SUBSCRIPTIONINFO } from './sUBSCRIPTIONINFO';


export interface CARDINFO {
    eis: EISSHORT;
    imei?: string;
    currentSubscription?: SUBSCRIPTIONINFO;
    /**
     * count of subscriptions on this card
     */
    numberOfSubscriptions: number;
    status: CARDINFO.StatusEnum;
    lastOperationDate?: Date;
    lastOperationStatus?: CARDINFO.LastOperationStatusEnum;
    lastSMTransactionDate?: Date;
    lastSMTransactionStatus?: CARDINFO.LastSMTransactionStatusEnum;
    /**
     * ID of the card group.If the value is 0, the card does not have a card group
     */
    cardGroupId: string;
    profilesList?: Array<SUBSCRIPTIONINFO>;
    keyset?: KEYSETINFO;
    certificate?: CERTIFICATE;
}
export namespace CARDINFO {
    export type StatusEnum = 'ACTIVE' | 'INACTIVE' | 'DIRTY' | 'PROCESSING' | 'FAILED';
    export const StatusEnum = {
        ACTIVE: 'ACTIVE' as StatusEnum,
        INACTIVE: 'INACTIVE' as StatusEnum,
        DIRTY: 'DIRTY' as StatusEnum,
        PROCESSING: 'PROCESSING' as StatusEnum,
        FAILED: 'FAILED' as StatusEnum
    }
    export type LastOperationStatusEnum = 'SUCCESS' | 'WARNING' | 'FAILED' | 'EXPIRED' | 'IN_PROCESS' | 'CANCELED' | 'UNKNOWN';
    export const LastOperationStatusEnum = {
        SUCCESS: 'SUCCESS' as LastOperationStatusEnum,
        WARNING: 'WARNING' as LastOperationStatusEnum,
        FAILED: 'FAILED' as LastOperationStatusEnum,
        EXPIRED: 'EXPIRED' as LastOperationStatusEnum,
        INPROCESS: 'IN_PROCESS' as LastOperationStatusEnum,
        CANCELED: 'CANCELED' as LastOperationStatusEnum,
        UNKNOWN: 'UNKNOWN' as LastOperationStatusEnum
    }
    export type LastSMTransactionStatusEnum = 'SUCCESS' | 'FAILED' | 'EXPIRED' | 'IN_PROCESS' | 'ENQUEUED' | 'CANCELED';
    export const LastSMTransactionStatusEnum = {
        SUCCESS: 'SUCCESS' as LastSMTransactionStatusEnum,
        FAILED: 'FAILED' as LastSMTransactionStatusEnum,
        EXPIRED: 'EXPIRED' as LastSMTransactionStatusEnum,
        INPROCESS: 'IN_PROCESS' as LastSMTransactionStatusEnum,
        ENQUEUED: 'ENQUEUED' as LastSMTransactionStatusEnum,
        CANCELED: 'CANCELED' as LastSMTransactionStatusEnum
    }
}



// WEBPACK FOOTER //
// ./src/gen/swagger-api/model/cARDINFO.ts